import { render, staticRenderFns } from "./IndexnoticeList.vue?vue&type=template&id=49bc6c58"
import script from "./IndexnoticeList.vue?vue&type=script&lang=js"
export * from "./IndexnoticeList.vue?vue&type=script&lang=js"
import style0 from "./IndexnoticeList.vue?vue&type=style&index=0&id=49bc6c58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports